var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-tag-input',_vm._b({ref:"field",attrs:{"value":_vm.selected_options,"options":_vm.filtered_options},on:{"search":_vm.search,"input":_vm.pick,"unpick":_vm.unpick}},'base-tag-input',_vm.base_tag_props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }